import type { RewardProgramName } from "../api/businessMetadataApi";

export const BUSINESS_LOYALTY_VALIDATION: Partial<
  Record<
    RewardProgramName,
    { pattern?: RegExp; maxLength?: number; errorMessage: string }
  >
> = {
  DeltaSkybonus: {
    maxLength: 12,
    errorMessage: "business-loyalty-programs.validation.delta_max_length",
  },
  Aadvantage: {
    pattern: /^[A-Za-z0-9]{7}$/,
    errorMessage: "business-loyalty-programs.validation.aadvantage_format",
  },
};

export const isValidAadvantageNumber = (value: string): boolean =>
  BUSINESS_LOYALTY_VALIDATION.Aadvantage?.pattern?.test(value) ?? false;
